interface LocationLike {
  pathname: string;
  search: string;
}

/**
 * Constrói o destino para onde o usuário deve ir após selecionar unidade/perfil.
 * Preserva o pathname e a query string atuais (deep link), removendo o parâmetro
 * `token` para não re-disparar o reset de perfil em navegações subsequentes.
 * Retorna `/` quando o destino resultante seria apenas a Home.
 */
export const buildPostProfileDestination = (location: LocationLike): string => {
  const pathname = location.pathname || '/';

  const params = new URLSearchParams(location.search || '');
  params.delete('token');
  const search = params.toString();

  if ((pathname === '/' || pathname === '') && !search) {
    return '/';
  }

  return search ? `${pathname}?${search}` : pathname;
};
